var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "dashboard-block" }, [
        _c(
          "div",
          { staticClass: "w-full flex flex-wrap justify-between items-center" },
          [
            _c(
              "ul",
              { staticClass: "nav nav-tabs", attrs: { role: "tablist" } },
              [
                _c(
                  "li",
                  { class: { active: _vm.filters.entity === "career" } },
                  [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          to: {
                            query: {
                              ..._vm.$route.query,
                              entity: "career",
                              type: "sport",
                              page: 1,
                            },
                          },
                        },
                      },
                      [_vm._v("Career")]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    class: {
                      active: _vm.filters.entity === "interest-categories",
                    },
                  },
                  [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          to: {
                            query: {
                              ..._vm.$route.query,
                              entity: "interest-categories",
                              page: 1,
                            },
                          },
                        },
                      },
                      [_vm._v("Interests")]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    class: {
                      active: _vm.filters.entity === "personal-interests",
                    },
                  },
                  [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          to: {
                            query: {
                              ..._vm.$route.query,
                              entity: "personal-interests",
                              page: 1,
                            },
                          },
                        },
                      },
                      [_vm._v("Hobbies")]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                !_vm.$vlastMode
                  ? _c(
                      "li",
                      {
                        class: { active: _vm.filters.entity === "description" },
                      },
                      [
                        _c(
                          "router-link",
                          {
                            attrs: {
                              to: {
                                query: {
                                  ..._vm.$route.query,
                                  entity: "description",
                                  type: "description",
                                  page: 1,
                                },
                              },
                            },
                          },
                          [_vm._v("Description")]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "li",
                  { class: { active: _vm.filters.entity === "sponsors" } },
                  [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          to: {
                            query: {
                              ..._vm.$route.query,
                              entity: "sponsors",
                              type: "sponsor",
                              page: 1,
                            },
                          },
                        },
                      },
                      [_vm._v("Sponsors")]
                    ),
                  ],
                  1
                ),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "tags-panel" }, [
          _c("div", { staticClass: "tags-panel__container" }, [
            _vm.filters.entity === "career"
              ? _c(
                  "div",
                  { staticClass: "tags-panel__column margin-r-1" },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "tags-panel__toolbar flex flex-wrap w-full",
                      },
                      [
                        _c("label", { staticClass: "control-label" }, [
                          _vm._v("Filter by tag group:"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "tags-panel__clear flex-shrink-0",
                            on: { click: _vm.resetTagType },
                          },
                          [_vm._v("Reset selection")]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("selectize", {
                      staticClass: "selectize selectize-single form-control",
                      attrs: {
                        name: "tag_type",
                        options: _vm.tagTypeOptions,
                        "disable-delete": true,
                      },
                      on: { input: _vm.handleGetEntities },
                      model: {
                        value: _vm.filters.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.filters, "type", $$v)
                        },
                        expression: "filters.type",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "tags-panel__column",
                class: { "margin-l-1": _vm.filters.entity === "career" },
              },
              [
                _c(
                  "form",
                  {
                    on: {
                      submit: function ($event) {
                        $event.preventDefault()
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "tags-panel__toolbar flex flex-wrap w-full",
                      },
                      [
                        _c("label", { staticClass: "control-label" }, [
                          _vm._v("Find a tag"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "tags-panel__clear",
                            attrs: { type: "button" },
                            on: { click: _vm.resetSearch },
                          },
                          [_vm._v("Reset search")]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "input-group" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.filters.term,
                            expression: "filters.term",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text", placeholder: "Search tags..." },
                        domProps: { value: _vm.filters.term },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(_vm.filters, "term", $event.target.value)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "input-group-btn" },
                        [
                          _c(
                            "ladda-button",
                            {
                              staticClass: "btn",
                              attrs: {
                                click: _vm.handleGetEntities,
                                type: "submit",
                              },
                            },
                            [_c("i", { staticClass: "fa fa-search" })]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]
                ),
              ]
            ),
          ]),
        ]),
        _vm._v(" "),
        _vm.filters.status === "active"
          ? _c(
              "div",
              { staticClass: "tags-panel" },
              [
                _c(
                  "system-tag-management-form",
                  {
                    attrs: {
                      "selected-tags": _vm.selectedTags,
                      "tag-type-options": _vm.tagTypeOptions,
                      loading: _vm.performingAction,
                    },
                    on: {
                      create: _vm.handleCreateEntity,
                      rename: _vm.handleRenameEntity,
                      merge: _vm.handleMergeEntities,
                      mergeInto: _vm.handleMergeIntoEntities,
                    },
                    model: {
                      value: _vm.selectedTags,
                      callback: function ($$v) {
                        _vm.selectedTags = $$v
                      },
                      expression: "selectedTags",
                    },
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "tags-panel__clear m-l-md flex-shrink-0",
                        attrs: { disabled: _vm.selectedTags.length < 1 },
                        on: { click: _vm.resetSelectedTags },
                      },
                      [_vm._v("Clear selection")]
                    ),
                  ]
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "tags-panel__table" }, [
          _c(
            "div",
            {
              staticClass: "w-full flex flex-wrap justify-between items-center",
            },
            [
              _c(
                "ul",
                { staticClass: "nav nav-tabs", attrs: { role: "tablist" } },
                [
                  _c(
                    "li",
                    { class: { active: _vm.filters.status === "active" } },
                    [
                      _c(
                        "router-link",
                        {
                          attrs: {
                            to: {
                              query: { ..._vm.$route.query, status: "active" },
                            },
                          },
                        },
                        [_vm._v("Active")]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    { class: { active: _vm.filters.status === "pending" } },
                    [
                      _c(
                        "router-link",
                        {
                          attrs: {
                            to: {
                              query: { ..._vm.$route.query, status: "pending" },
                            },
                          },
                        },
                        [_vm._v("Pending")]
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "table",
            { staticClass: "table table-hover table-tags table-data" },
            [
              _c("thead", [
                _c("tr", [
                  _c("th", { staticClass: "check" }),
                  _vm._v(" "),
                  _c("th", { staticClass: "name" }, [_vm._v("Tag Name")]),
                  _vm._v(" "),
                  _c("th", { staticClass: "occurrences" }, [
                    _vm._v("Occurrences"),
                  ]),
                  _vm._v(" "),
                  _c("th", { staticClass: "delete" }, [_vm._v("Delete")]),
                  _vm._v(" "),
                  _vm.hasEditPage
                    ? _c("th", { staticClass: "manage" }, [_vm._v("Manage")])
                    : _vm._e(),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "tbody",
                [
                  _vm.fetchingTags
                    ? _c("tr", [_vm._m(1)])
                    : _vm.haveNoEntities
                    ? _c("tr", [
                        _c(
                          "td",
                          {
                            staticClass: "text-center",
                            attrs: { colspan: "4" },
                          },
                          [
                            _vm._v(
                              "\n                There are no tags. Check the tag type or search term.\n              "
                            ),
                          ]
                        ),
                      ])
                    : _vm._l(_vm.currentEntityList, function (tag) {
                        return _c("system-tag-management-list-item", {
                          key: tag.id,
                          attrs: { tag: tag, "has-edit": _vm.hasEditPage },
                          on: { delete: _vm.handleDeleteEntity },
                          model: {
                            value: _vm.selectedTags,
                            callback: function ($$v) {
                              _vm.selectedTags = $$v
                            },
                            expression: "selectedTags",
                          },
                        })
                      }),
                ],
                2
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _vm.filters.status === "pending" && _vm.selectedTags.length > 0
          ? _c("div", { staticClass: "flex justify-end" }, [
              _c(
                "div",
                { staticClass: "margin-r-1", staticStyle: { width: "200px" } },
                [
                  _vm.filters.entity === "interest-categories" || "career"
                    ? _c("selectize", {
                        staticClass: "selectize selectize-single form-control",
                        attrs: {
                          name: "tag_type",
                          options: _vm.tagTypeOptions,
                          "disable-delete": true,
                        },
                        model: {
                          value: _vm.interestCategoryApproveGroup,
                          callback: function ($$v) {
                            _vm.interestCategoryApproveGroup = $$v
                          },
                          expression: "interestCategoryApproveGroup",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "approve-tags-btn btn btn-success",
                  on: { click: _vm.handleApproveEntities },
                },
                [
                  _vm._v(
                    "\n          Approve Selected (" +
                      _vm._s(_vm.selectedTags.length) +
                      ")\n        "
                  ),
                ]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "flex flex-wrap w-full" },
          [
            _c("system-tag-management-pagination", {
              staticClass: "w-full",
              attrs: { pagination: _vm.currentEntityPagination },
              on: { changePage: _vm.handleUpdatePagination },
            }),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "dashboard-page-title" }, [
      _c("div", { staticClass: "container-fluid" }, [
        _c("h1", [_vm._v("Tag Management")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", { staticClass: "text-center", attrs: { colspan: "4" } }, [
      _c("i", {
        staticClass: "fa fa-circle-o-notch fa-spin fa-2x fa-fw text-muted",
      }),
      _vm._v(" "),
      _c("span", { staticClass: "sr-only" }, [_vm._v("Loading...")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }